import { render, staticRenderFns } from "./SideNav.vue?vue&type=template&id=eeee89bc&scoped=true"
import script from "./SideNav.vue?vue&type=script&lang=ts"
export * from "./SideNav.vue?vue&type=script&lang=ts"
import style0 from "./SideNav.vue?vue&type=style&index=0&id=eeee89bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeee89bc",
  null
  
)

export default component.exports